export default __webpack_public_path__ + "static/media/fuelEnDetailRompetrolMobile.77059f45.jpg";